<template>
  <NsiTable :pageTitle="pageTitle" :apiRoute="apiRoute" :cardName="cardName" :canEdit="canEdit" />
</template>

<script>
  import NsiTable from '../components/NsiTable.vue';

  export default {
    name: 'TnvedIndustry',
    components: {
      NsiTable,
    },
    data() {
      return {
        pageTitle: 'Отрасли для товаров',
        canEdit: true,
        apiRoute: 'nsitnvedindustry',
        cardName: 'TnvedIndustryCard',
      };
    },
    created() {},
    methods: {},
  };
</script>
